import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  getOfficialTypesForHockey,
  getOfficialTypesForSoccer,
  getTeamOfficialTypesForHockey,
  getTeamOfficialTypesForSoccer,
} from '@sportninja/common/selectors/types'
import { t } from '@sportninja/common/i18n'

import { SelectFormInput } from '../Select'
import { isCanlan } from '@sportninja/common/utils/customer-name'

const OfficialSelect = ({
  officialTypesForHockey,
  teamOfficialTypesForHockey,
  officialTypesForSoccer,
  teamOfficialTypesForSoccer,
  disabled,
  defaultValue,
  label = t('common:role'),
  noFlex,
  onChange,
  name,
  isTeamOfficialType = false,
  hasError,
  types: _types,
  isSoccer = false,
  isOrg = false,
}) => {
  let officialTypes = isSoccer ? officialTypesForSoccer : officialTypesForHockey
  if (isOrg && !isCanlan) {
    const officialTypesForSoccerWithModifiedName = officialTypesForSoccer.map(
      (type) => {
        return {
          ...type,
          name_full: `${type?.name_full} (Soccer)`,
          name: `${type?.name} (Soccer)`,
        }
      }
    )
    const officialTypesForHockeyWithModifiedName = officialTypesForHockey.map(
      (type) => {
        return {
          ...type,
          name_full: `${type?.name_full} (Hockey)`,
          name: `${type?.name} (Hockey)`,
        }
      }
    )
    officialTypes = [
      ...officialTypesForSoccerWithModifiedName,
      ...officialTypesForHockeyWithModifiedName,
    ]
  } else {
    officialTypes = isSoccer ? officialTypesForSoccer : officialTypesForHockey
  }

  const teamOfficialTypes = isSoccer
    ? teamOfficialTypesForSoccer
    : teamOfficialTypesForHockey

  const types =
    Array.isArray(_types) && _types.length > 0
      ? _types
      : isTeamOfficialType
      ? teamOfficialTypes
      : officialTypes
  const [selectedType, setSelectedType] = useState(defaultValue)

  const onSelect = ({ target }) => {
    onChange({ target })
    setSelectedType(target.value)
  }

  return (
    <SelectFormInput
      defaultValue={selectedType}
      disabled={types.length === 0 || disabled}
      label={`${t('util:capitalize', { text: label })} *`}
      name={name}
      noFlex={noFlex}
      onChange={onSelect}
      hasError={hasError}
    >
      <option key='line'></option>
      {Array.isArray(types) &&
        types.map((type) => {
          return (
            <option key={type?.id} value={type?.id}>
              {type?.name}
            </option>
          )
        })}
    </SelectFormInput>
  )
}

OfficialSelect.propTypes = {
  officialTypes: PropTypes.array.isRequired,
  teamOfficialTypes: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.number,
  noFlex: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    officialTypesForHockey: getOfficialTypesForHockey(state),
    teamOfficialTypesForHockey: getTeamOfficialTypesForHockey(state),
    officialTypesForSoccer: getOfficialTypesForSoccer(state),
    teamOfficialTypesForSoccer: getTeamOfficialTypesForSoccer(state),
  }
}

export default connect(mapStateToProps)(OfficialSelect)
